function VirtualSKUStepEditForm() {
	return {
		fields: [
			'virtualSKUStep.productVirtualSkus',
			'virtualSKUStep.productVirtualSkus[].id',
			'virtualSKUStep.productVirtualSkus[].sku',
			'virtualSKUStep.productVirtualSkus[].channel',
			'virtualSKUStep.productVirtualSkus[].description',
			'virtualSKUStep.productVirtualSkus[].isActive',
			'virtualSKUStep.productVirtualSkus[].isNonPrime',
			'virtualSKUStep.productVirtualSkus[].searchId',
			'virtualSKUStep.productVirtualSkus[].postInventory',
			'virtualSKUStep.productVirtualSkus[].carriers',
		],
		labels: {
			'virtualSKUStep.productVirtualSkus[].sku': 'PRODUCTVIEW.VIRTUALSKU',
			'virtualSKUStep.productVirtualSkus[].channel': 'PRODUCTVIEW.CHANNEL',
			'virtualSKUStep.productVirtualSkus[].description': 'PRODUCTVIEW.DESCRIPTION',
			'virtualSKUStep.productVirtualSkus[].isActive': 'PRODUCTVIEW.ISACTIVE',
			'virtualSKUStep.productVirtualSkus[].isNonPrime': 'PRODUCTVIEW.ISNONPRIME',
			'virtualSKUStep.productVirtualSkus[].postInventory': 'PRODUCTVIEW.POSTINVENTORY',
			'virtualSKUStep.productVirtualSkus[].carriers': 'PRODUCTVIEW.CARRIERS',
		},
		rules: {
			'virtualSKUStep.productVirtualSkus[].sku': 'required',
			'virtualSKUStep.productVirtualSkus[].channel': 'required',
		},
	};
}

export default VirtualSKUStepEditForm;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/forms/VirtualSKUStepEditForm.js